import { LoadingIndicator } from '@cfa/react-components';

import { withRoles } from '@/components/ConfirmationModal/withRoles';

import { HeaderTitle } from './components';
import Categories from './components/MainOverview/Categories';
import DeleteModal from './components/MainOverview/DeleteModal';
import ManagingCountry from './components/MainOverview/ManagingCountry';
import Recommended from './components/MainOverview/Recommended';
import ToggleVisibilityModal from './components/MainOverview/ToggleVisibilityModal';
import { useCategories } from './data';

const Admin = () => {
  const { isLoading } = useCategories();

  return (
    <div className="flex justify-center px-4">
      <div className="max-w-content w-full">
        <HeaderTitle />
        <ManagingCountry />
        {isLoading ? (
          <div className="flex justify-center">
            <LoadingIndicator size="lg" variant="page" />
          </div>
        ) : (
          <>
            <Recommended />
            <Categories />
          </>
        )}
        <DeleteModal />
        <ToggleVisibilityModal />
      </div>
    </div>
  );
};

const AdminWithRoles = withRoles(Admin, 'admin');

export default AdminWithRoles;
